import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';

import { NbAuthService } from '@nebular/auth';

import * as _ from 'lodash-es';
import { NbRoleProvider } from '@nebular/security';
import { adminOrOperatorRole, monitorRole } from '@hm_app/_helpers/roles';

@Injectable()
export class AdminAuthGuard implements CanActivate, CanActivateChild {

    constructor(
        private authService: NbAuthService,
        private roleProvider: NbRoleProvider,
        private router: Router,
    ) { }

    async canActivate() {
        if (!this.authService.isAuthenticated()) {
            return false;
        }
        const roles = await this.roleProvider.getRole().toPromise();
        if (adminOrOperatorRole(roles) || monitorRole(roles)) {
            return true;
        }

        this.router.navigate(['/users']);
        return false;

    }

    async canActivateChild() {
        return this.canActivate();
    }

}
